import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { JOB_API } from "./apiRoutes";

interface UseGetNewsMediaByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getNewsMediaById = async (id: string) =>
  await axiosAuth.get(`${JOB_API}/job/${id}`);

const useGetNewsMediaById = ({
  id,
  queryParams,
}: UseGetNewsMediaByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["news-media", id],
    queryFn: () => getNewsMediaById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetNewsMediaById;
